"use strict";

window.SlamJam = window.SlamJam || {};

$(function () {
    //
    SlamJam.Cart = {};

    /**
     * Check Limit product on cart
     *
     * @param {*} product_id prodotto da aggiungere
     * @param {int} variant_id  = Variante da aggiungere
     * @param {int} newQty  = Nuove qta da aggiungere
     * @param {int} limitProduct  = 0 nessun limite
     * @param {*} onePairPerCustomer
     * @param {*} onePerCustomer
     */
    SlamJam.Cart.checkLimiter = function (product_id, variant_id, newQty) {
        var limitProduct = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
        var onePairCustomer = arguments[4];
        var onePerCustomer = arguments[5];


        var deferred = $.Deferred();

        if (limitProduct > 0) {
            var QtyForProduct_id = 0; //Qta nel carrello per id prodotto
            $.ajax({
                url: '/cart.js',
                dataType: "json",
                cache: false,
                success: function success(cart) {
                    var _resolve = true;
                    for (var j = 0; j < cart.items.length; j++) {
                        //Gestione check q.ty solo per variante

                        if (onePairCustomer == true) {
                            limitProduct = 1;

                            if (cart.items[j].product_id + "" == product_id + "") {
                                //Controllo per prodotto
                                //if(cart.items[j].product_id + "" == product_id + "" ){
                                QtyForProduct_id = QtyForProduct_id + parseInt(cart.items[j].quantity);
                                break;
                            }
                        } else {
                            if (cart.items[j].variant_id + "" == variant_id + "") {
                                //Controllo per prodotto
                                //if(cart.items[j].product_id + "" == product_id + "" ){
                                QtyForProduct_id = QtyForProduct_id + parseInt(cart.items[j].quantity);
                                break;
                            }
                        }
                    };

                    // Le q.ta presenti più quelle che si vogliono aggiungere non devono eccedere il limite massimo
                    if (QtyForProduct_id + parseInt(newQty) <= parseInt(limitProduct)) {
                        deferred.resolve(true);
                    } else {
                        deferred.reject();
                    }
                }
            });
        } else {
            deferred.resolve(true);
        }
        console.groupEnd();
        return deferred.promise();
    },

    /**
     * Aggiunge un elemento al carrello  solo se non è stato superato il limite  "limitProduct" (Totale prodotti ammissibili in carrello)
     *
     * @param {*} productId prodotto da aggiungere
     * @param {*} variantId variante da aggiungere
     * @param {*} qtyToAdd Q.ta da aggiungere al carrello
     * @param {*} limitProduct numero massimo di prodotti inseribili nel carrello  = 0 illimitato
     * @param {*} _data dati serializzati da inviare alla chiamta /car/add.js  se qta. se qta non viene specificata di deafult = 1
     * @param {*} onePairPerCustomer
     * @param {*} onePerCustomer
     * @param {*} doneCallback se NULL viene avviata quella di default
     * @param {*} errorCallback se NULL viene avviata quella di default
     */
    SlamJam.Cart.addItem = function (productId, variantId, qtyToAdd, limitProduct, _data, onePairPerCustomer, onePerCustomer) {
        var doneCallback = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;
        var errorCallback = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : null;
        var errorCheckLimeterCallBack = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : null;

        SlamJam.Cart.checkLimiter(productId, variantId, qtyToAdd, limitProduct, onePairPerCustomer, onePerCustomer).done(function (sendAdd) {
            if (sendAdd === true) {

                var params = {
                    type: 'POST',
                    url: '/cart/add.js',
                    data: _data,
                    dataType: 'json',
                    success: function success(line_item) {
                        if (typeof doneCallback === 'function') {
                            doneCallback(line_item);

                            /* tracciamenti GoogleTagManager */
                            var gtmEventAddToCart = new CustomEvent("gtmEventAddToCart", { 'detail': line_item });
                            document.dispatchEvent(gtmEventAddToCart);

                            if (template == 'cart') {
                                //SlamJam.pageRedirect('/cart');  // Da problemi con le connessioni lente, non viene aggiornato correttamente il dato a schermo
                            }
                        } else {
                            SlamJam.Cart.onItemAdded(line_item);
                        }
                    },
                    error: function error(XMLHttpRequest, textStatus) {
                        if (typeof errorCallback === 'function') {
                            errorCallback(XMLHttpRequest, textStatus);
                        } else {
                            SlamJam.Cart.onErrorAdded(XMLHttpRequest, textStatus);
                        }
                    }
                };

                jQuery.ajax(params);
            }
        }).fail(function () {
            $('body').trigger('hide-loading', { handle: 'generic-loading' });

            if (typeof errorCheckLimeterCallBack === 'function') {
                errorCheckLimeterCallBack();
            } else {
                if (SlamJam.strings.dropInstance == false) {
                    SlamJam.Cart.onErrorCheckLimiter(SlamJam.strings.addToCart_limitQty_reached);
                }
            }
        });
    };

    SlamJam.Cart.changeItem = function (_data) {
        var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
        var errorCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

        var params = {
            type: 'POST',
            url: '/cart/change.js',
            data: _data,
            dataType: 'json',
            success: function success(line_item) {
                if (typeof callback === 'function') {
                    callback(line_item);
                } else {
                    SlamJam.Cart.onItemChagned(line_item);
                }
            },
            error: function error(XMLHttpRequest, textStatus) {
                if (typeof errorCallback === 'function') {
                    errorCallback(XMLHttpRequest, textStatus);
                } else {
                    SlamJam.Cart.onErrorChagned(XMLHttpRequest, textStatus);
                }
            }
        };

        jQuery.ajax(params);
    };

    /*
     * Dichiaro la variabile per poter creare la select della quantità
     * quando viene aperta la modal EditCart
     */
    var selectTag = $('<select class="quantity-dropdown" />');

    SlamJam.editItem = function (popUpObject, currentHandle, oldVariant, variantQuantity) {
        // vado a chiamare il product template con la vista del template necessario "ajax-update"
        $.ajax({
            url: '/products/' + currentHandle + '?variant=' + oldVariant + '&view=ajax-update',
            success: function success(result) {
                $('body').trigger('hide-loading', {
                    handle: 'generic-loading'
                });

                popUpObject.find('.popup-content').html(result);

                var productTemplateQuickView = new ProductTemplateQuickView($('#EditCart'), $('.popup-content'));

                $(productTemplateQuickView.productSelectVariantCollection).on('select-variant-dropdown-closed', function (e) {
                    //Remove error messages
                    var errorMessageWrapper = $('.error-message-wrapper.ajax-update');

                    errorMessageWrapper.html('').removeClass('visible');
                });

                var preventClose = true;

                var newVariantId = oldVariant; // Imposto ad old così nel caso in cui l'utente non cambia la taglia nella select non avvio l'insert ma chiudo solo la modal

                // Se non sono in Drop
                if (SlamJam.strings.dropInstance == false) {

                    /*
                    * Imposto la variabile per creare la select con la quantità massima della variante nel carrello
                    * così se cambia variante posso fare un check e ricreare la select con i nuovi valori giusti
                    */
                    // var inventoryQuantity = maxVariantQty; // Commented out so it doesn't show remaining stock quantity in the select
                    var inventoryQuantity = variantQuantity; // The max quantity one can select is the quantity of the variant in the cart
                    var qtyMaxOne = maxOne;

                    // Creo la select della quantity con la funzione
                    createSelect(inventoryQuantity, qtyMaxOne);
                }

                /*
                 * Quando seleziono una variante diversa mi prendo:
                 * - id della nuova variante,
                 * - la quantità massima della nuova variante
                 * - ricrea la select con la nuova quantità massima
                 */
                $(productTemplateQuickView.productSelectVariantCollection).on('selected-variant', function (e, itemClicked, variantId) {
                    newVariantId = variantId; // mi vado a catturare la nuova variante del prodotto

                    // Se non sono in Drop
                    if (SlamJam.strings.dropInstance == false) {
                        // inventoryQuantity = $('.product-details__dx .product-select-variant__value.active').data('variant-inventory'); // Commented out since the data attribute was removed in order not to show the stock quantity on frontend
                        createSelect(inventoryQuantity, qtyMaxOne);
                    }
                });

                // Se non sono in Drop


                // Imposto la nuova quantità uguale a quella già presente nel carrello per controlli futuri
                var newVariantQuantity = variantQuantity;

                /*
                 * Salvo dentro newVariantQuantity il nuovo valore selezionato con la dropdown
                 * e viene richiamata la funzione per il check del pulsante update
                 */
                $('.quantity-dropdown').change(function () {
                    newVariantQuantity = $(this).val();

                    checkQuantity();
                });

                /*
                 * Funzione per controllare il cambio della quantità.
                 *
                 * Se cambio la quantità iniziale abilito il pulsante update
                 */

                function checkQuantity() {
                    if (newVariantQuantity != variantQuantity) {
                        $('#AddToCart-').removeClass('btn--disabled').prop('disabled', false);
                    } else if (newVariantQuantity == variantQuantity && oldVariant == newVariantId) {
                        $('#AddToCart-').addClass('btn--disabled').prop('disabled', true);
                    }
                }

                /*
                 * Funzione per creare la select della quantità.
                 *
                 * Inizialmente viene creata con la quantità disponibile della variante già nel carrello
                 *
                 * Quando si cambia variante, la select viene svuotata e
                 * riempita con la quantità disponibile della variante scelta
                 *
                 * Infine viene inizializzato select2 così da dare lo stile e
                 * mostrare già la quantità presente nel carrello della variante originale
                 */

                function createSelect(inventoryQuantity, qtyMaxOne) {
                    console.log(qtyMaxOne);
                    if (qtyMaxOne) {
                        inventoryQuantity = 1;
                    }
                    var i = 0;
                    selectTag.empty(); // Prima di ricreare la select la svuoto

                    if (inventoryQuantity == variantQuantity && oldVariant == newVariantId) {
                        for (i = 1; i <= inventoryQuantity; i++) {
                            $('<option />', { value: i, text: i }).appendTo(selectTag);
                        }
                    } else {
                        for (i = 1; i <= inventoryQuantity; i++) {
                            $('<option />', { value: i, text: i }).appendTo(selectTag);
                        }
                    }

                    selectTag.appendTo('.add-to-cart-wrapper');

                    $(selectTag).select2({
                        width: '100%',
                        minimumResultsForSearch: Infinity
                    }).val(variantQuantity).trigger("change"); // Quì seleziona già la quantità presente nel carrello
                }

                $('#AddToCart-').click(function (e) {
                    e.preventDefault();
                    // qui dichiaro un oggetto contente i nuovi dati da aggiungere /

                    /* Controllo i due casi:
                     * - Variante diversa
                     * - Stessa variante ma quantità diversa
                     */

                    var updateMassiveFlag = true;
                    if (oldVariant !== newVariantId || oldVariant == newVariantId && variantQuantity !== newVariantQuantity) {

                        // Dichiaro l'oggetto contente i nuovi dati da aggiungere con la chiamata cart/add
                        if (oldVariant !== newVariantId) {
                            var productToAdd = {
                                'id': newVariantId,
                                'quantity': newVariantQuantity
                            };
                        } else if (oldVariant == newVariantId && variantQuantity !== newVariantQuantity) {
                            updateMassiveFlag = false;

                            var productToAdd = {
                                'id': newVariantId,
                                'quantity': newVariantQuantity
                            };

                            SlamJam.Cart.changeItem(productToAdd, function () {
                                location.reload();
                            });
                        }

                        if (updateMassiveFlag == true) {
                            $('body').trigger('show-loading', {
                                handle: 'generic-loading'
                            });

                            SlamJam.Cart.addItem(productTemplateQuickView.form.data('product-id'), newVariantId, variantQuantity, productTemplateQuickView.form.data('limiter'), productToAdd, productTemplateQuickView.form.data('one-pair-per-customer'), function () {

                                /* Dichiaro un oggetto con i dati da rimuovere con la cart/change.
                                 * Se cambio variante, rimuovo la vecchia
                                 * altrimenti se ho la stessa variante cambio la quantità
                                 */
                                if (oldVariant !== newVariantId) {
                                    var productToRemove = {
                                        'quantity': 0,
                                        'id': oldVariant.toString()
                                    };
                                } else if (oldVariant == newVariantId && variantQuantity !== newVariantQuantity) {
                                    var productToRemove = {
                                        'quantity': newVariantQuantity,
                                        'id': oldVariant.toString()
                                    };
                                }

                                SlamJam.Cart.changeItem(productToRemove, function () {
                                    setTimeout(function () {
                                        location.reload();
                                    }, 1000);
                                }, function (err) {
                                    console.warn('Something went wrong.', err);
                                });
                            }, function (XMLHttpRequest, textStatus) {
                                $('body').trigger('hide-loading', {
                                    handle: 'generic-loading'
                                });

                                //SlamJam.showPopUpErrorFromAjaxRequest(XMLHttpRequest);
                                var data = eval('(' + XMLHttpRequest.responseText + ')');

                                if (!!data.message) {
                                    if (data.status == 422 || data.status == "bad_request") {
                                        var errorMessageWrapper = $('.error-message-wrapper.ajax-update');
                                        errorMessageWrapper.html(data.description).addClass('visible');
                                    }
                                }
                            }, function () {
                                var errorMessageWrapper = $('.error-message-wrapper.ajax-update');
                                errorMessageWrapper.html(SlamJam.strings.addToCart_limitQty_reached).addClass('visible');
                            });
                        }
                    } else {
                        $('.modal').find('.modal__close').click();
                    }
                });

                // SlamJam.closeModal(false, preventClose); // Commented out since it was doubling the close event and causing the page to reload (initially it was SlamJam.closeModal(preventClose);)
            }
        });
    };

    SlamJam.Cart.onErrorCheckLimiter = function (text) {
        $("#errors").find('.popup-content').html(text);
        $("#errors").addClass('active');

        SlamJam.closeModal();
    };

    SlamJam.Cart.onErrorAdded = function (_ref, textStatus) {
        $("#errors").find('.popup-content').html(textStatus);
        $("#errors").addClass('active');

        SlamJam.closeModal();
    };
    SlamJam.Cart.onItemChagned = function (line_item, form) {
        //todo
    };

    SlamJam.Cart.onErrorChagned = function (_ref, textStatus) {
        //todo
    };
});